import React, { useEffect } from "react";
import Swal from "sweetalert2";

// Simple decryption for company ID
const decryptId = (encrypted) => {
  try {
    const decoded = atob(encrypted);
    const prefix = 'bic_enc_';
    if (decoded.startsWith(prefix)) {
      return decoded.substring(prefix.length);
    }
    return null;
  } catch (e) {
    return null;
  }
};

function StripeConnect() {
  
  const API_URL = process.env.REACT_APP_API_URL || "https://api.bookinclass.co.uk/api/";

useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const encryptedCompany = params.get("state");
    const company = decryptId(encryptedCompany);

    if (code) {
      const token = localStorage.getItem("token");
      Swal.fire({
        title: 'Please wait...',
        text: 'We are fetching your Stripe account details',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      fetch(`${API_URL}company/stripe/exchange-token`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Token": token },
        body: JSON.stringify({ code, company }),
      })
        .then((res) => res.json())
        .then((data) => {
          Swal.close();

          if (data.data.stripe_account_id) {

            Swal.fire({
              title: 'Success!',
              text: 'Stripe account connected successfully',
              icon: 'success',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                const isProfileComplete = data.data.is_profile_complete == 1;
                const isBasicProfileComplete = data.data.is_basic_profile_complete == 1;
                if (!isProfileComplete && isBasicProfileComplete) {
                  localStorage.setItem('showOnboardingAfterProfileComplete', 'true');
                  window.location.href = '/teacher';
                } else {
                  window.location.href = `/company/edit/${data.data.company}`;
                }
              }
            });

          } else {
            Swal.fire({
              title: 'Error!',
              text: 'Failed to connect Stripe account. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = `/company/edit/${data.data.company}`;
              }
            });
          }
        })
        .catch((error) => {
          Swal.close();

          Swal.fire({
            title: 'Error!',
            text: 'Failed to connect Stripe account. Please try again.',
            icon: 'error'
          });
        });
    }
}, []);

  return (
   <article></article>
  );
}

export default StripeConnect;
